import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";
import { showSuccessNotification } from "@utils/showNotification";

import { patientQKeys } from "@hooks/queries/patient/queryKeys";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import { PatientAllergy } from "@customTypes/patient";


export const useCreateAllergy = () => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: (data: PatientAllergy) => {
      return api.post(`patient/allergy`, {
        patient_id: data.patientId,
        allergy: data.allergy,
        severity: data.severity,
        diagnosis_date: data.date,
      });
    },
    onSuccess: res => {
      // console.log(res);
      showSuccessNotification({
        title: "success",
        message: "create-allergy-success",
      });
      queryClient.invalidateQueries({
        queryKey: patientQKeys.allergy(res.data.patient_id),
      });
    },

    onError: (res: any) => {
      console.error("[From Create Allergy]", res);

      handleErrors(res, "mutation");
    },
  });
};
